import { useDispatch } from 'react-redux';
import { Form, Input } from 'antd';

import useAppSelector from 'hooks/useAppSelector';
import { Shipping, ShippingWay } from 'models/auction/Shipping';
import {
  setAuctionFormState,
  clearShippingMethodError,
  createShippingMethod,
  removeShippingMethod,
  updateShippingMethod,
} from 'features/auctionFormSlice';

import ShippingForm from './ShippingForm/ShippingForm';

const { TextArea } = Input;

function TradeForm() {
  const dispatch = useDispatch();
  const { shippingMethods, payment, returnPolicy, errors } = useAppSelector((state) => state.auctionForm);

  const _createShippingMethod = (shippingMethod: Shipping) => {
    dispatch(createShippingMethod(shippingMethod));
  };

  const _updateShippingMethod = (keyDescription: string, newShippingMethod: Shipping) => {
    dispatch(updateShippingMethod({ keyDescription, newShippingMethod }));
  };

  const _removeShippingMethod = (type: ShippingWay, keyDescription: string) => {
    dispatch(removeShippingMethod({ type, keyDescription }));
  };

  return (
    <Form layout="vertical">
      <ShippingForm
        type="in_person"
        label="직거래 장소"
        insertMessage="+ 직거래 가능 시 장소를 추가해주세요"
        shippingMethods={shippingMethods}
        createShippingMethod={_createShippingMethod}
        updateShippingMethod={_updateShippingMethod}
        removeShippingMethod={_removeShippingMethod}
        errors={errors}
        clearError={() => dispatch(clearShippingMethodError())}
      />

      <ShippingForm
        type="parcel"
        label="배송 정보"
        insertMessage="+ 배송 가능 시 배송 정보를 추가해주세요"
        shippingMethods={shippingMethods}
        createShippingMethod={_createShippingMethod}
        updateShippingMethod={_updateShippingMethod}
        removeShippingMethod={_removeShippingMethod}
        errors={errors}
        clearError={() => dispatch(clearShippingMethodError())}
      />

      <Form.Item label="입금 받을 계좌 정보" validateStatus={errors.includes('payment') ? 'error' : ''} required>
        <Input
          placeholder="천원은행 123-456-789012 홍길동"
          value={payment}
          onChange={(e) => dispatch(setAuctionFormState({ payment: e.target.value }))}
        />
      </Form.Item>

      <Form.Item label="반품 및 교환 정책" validateStatus={errors.includes('returnPolicy') ? 'error' : ''} required>
        <TextArea
          placeholder="반품 및 교환에 관한 정책을 작성해주세요"
          value={returnPolicy}
          onChange={(e) => dispatch(setAuctionFormState({ returnPolicy: e.target.value }))}
        />
      </Form.Item>
    </Form>
  );
}

export default TradeForm;
